<template>
<CRow>
    <CCol col="12">
        <a href="https://github.com/affili-ir/affili-js/" class="text-affili-indigo" target="_blank">
            <FaIcon :icon="['fab', 'github']" class="fa-2x float-md-right mx-auto d-block mb-3" />
        </a>

        <!-- <a href="https://wordpress.org/plugins" class="text-affili-indigo" target="_blank">
            <FaIcon :icon="['fab', 'wordpress']" class="fa-2x float-md-right mfe-2 d-block mb-3" />
        </a> -->
        <a href="https://github.com/affili-ir/wordpress/archive/3.1.2.zip" class="text-affili-indigo" target="_blank" download>
            <FaIcon :icon="['fab', 'wordpress']" class="fa-2x float-md-right mfe-2 d-block mb-3" />
        </a>
    </CCol>
    <CCol col="12">
        <CCard>
            <CCardBody>
                <CListGroup dir="ltr" class="p-0">
                    <CListGroupItem class="text-left">
                        <CButton color="primary" class="mr-2" v-clipboard:copy="current.account_id" v-clipboard:success="accountIdCopied">
                            <FaIcon icon="copy" />
                        </CButton>
                        <span class="font-weight-bold">ACCOUNT ID:</span> {{ current.account_id }}
                        <span v-if="accountIdCopyStatus" class="text-success font-weight-bold mt-2 mx-3">{{ $t('developer.copied') }}</span>
                    </CListGroupItem>

                    <CListGroupItem class="text-left">
                        <CButton color="primary" class="mr-2" v-clipboard:copy="current.access_id" v-clipboard:success="accessIdCopied">
                            <FaIcon icon="copy" />
                        </CButton>
                        <span class="font-weight-bold">ACCESS ID:</span> {{ current.access_id }}
                        <span v-if="accesstIdCopyStatus" class="text-success font-weight-bold mt-2 mx-3">{{ $t('developer.copied') }}</span>
                    </CListGroupItem>
                </CListGroup>

            </CCardBody>
        </CCard>
    </CCol>
    <CCol col="12">
        <CCard>
            <CCardHeader>
                <h4>{{ $t('developer.section4._') }}</h4>
            </CCardHeader>
            <CCardBody>
                <p v-html="$t('developer.section4.description')"></p>
                <ul>
                    <li v-for="(item, index) in dataWhereSaved" v-bind:key="index" v-html="item"></li>
                </ul>
            </CCardBody>
        </CCard>
    </CCol>
    <CCol col="12">
        <CCard>
            <CCardHeader>
                <h4>{{ $t('developer.section3._') }}</h4>
            </CCardHeader>
            <CCardBody>
                <p v-for="(how, index) in howToWorkDescription" v-bind:key="index" v-html="how"></p>
            </CCardBody>
        </CCard>
    </CCol>
    <CCol col="12">
        <CCard>
            <CCardHeader>
                <h4>آموزش پیاده سازی اسکریپت افیلی</h4>
            </CCardHeader>
            <CCardBody>
                <MarkdownDisplay :markdown="markdown" />
            </CCardBody>
        </CCard>
    </CCol>
</CRow>
</template>

<script>
import { mapGetters } from 'vuex'
import { MarkdownDisplay } from '@/components'
import markdown from './partials/markdown.js'

export default {
    name: 'AffiliScriptMerchants',
    components: {
        MarkdownDisplay,
    },
    data() {
        return {
            accountIdCopyStatus: false,
            accesstIdCopyStatus: false,
            markdown,
        }
    },
    computed: {
        ...mapGetters('user', [
            'current'
        ]),

        howToWorkDescription() {
            return [
                this.$t('developer.section3.list.track'),
                this.$t('developer.section3.list.save_cookie'),
                this.$t('developer.section3.list.make_conversion')
            ]
        },
        dataWhereSaved() {
            return [
                this.$t('developer.section4.list.view_data'),
                this.$t('developer.section4.list.get_data'),
                this.$t('developer.section4.list.browser'),
                this.$t('developer.section4.list.device'),
                this.$t('developer.section4.list.pages'),
                this.$t('developer.section4.list.ip'),
            ]
        }
    },
    methods: {
        accountIdCopied() {
            this.accountIdCopyStatus = true
            setTimeout(() => {
                this.accountIdCopyStatus = false
            }, 1000)
        },
        accessIdCopied() {
            this.accesstIdCopyStatus = true
            setTimeout(() => {
                this.accesstIdCopyStatus = false
            }, 1000)
        }
    }
}
</script>

<style lang="scss">
    .span-style > span {
        font-weight: 700 !important;
        background-color: #ebedef !important;
    }
</style>
